import { Link } from "react-router";

export default function Path(props){
  const path = props.path ?? [];
  return (
    <div className={`${props.className} flex items-center`}>
      <div key="img">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="18px" fill="#707070">
          <path d="M240-200h120v-240h240v240h120v-360L480-740 240-560v360Zm-80 80v-480l320-240 320 240v480H520v-240h-80v240H160Zm320-350Z"/>
        </svg>
      </div>
      {path.map(p=> (
        <div key={p.name} className="flex items-center">
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="18px" fill="#5f6368">
            <path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z"/>
          </svg>
          <Link key={p.name} to={p.url} style={{color:'#707070'}}>
            <p className="text-[13px] lg:text-base">{p.name}</p>
          </Link>
        </div>) 
      )}
    </div>
  );
}